import m from "../../geodata/es2015/usaAlbersHigh";
window.am4geodata_usaAlbersHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/usaAlbersHigh.js
// module id = null
// module chunks = 